<div class="bank-account-info-card">
  <p class="bank-account-info-card__title">{{ title }}</p>
  <p class="bank-account-info-card__item"><strong>BANCO:</strong> {{ changes.bank_name }}</p>
  <p class="bank-account-info-card__item"><strong>CÓDIGO:</strong> {{ changes.bank_code }}</p>
  <p class="bank-account-info-card__item"><strong>AGÊNCIA:</strong> {{ changes.agency }}</p>
  <p class="bank-account-info-card__item">
    <strong>CONTA:</strong> {{ changes.account_number }} - {{ changes.account_digit }}
  </p>
  <p class="bank-account-info-card__item"><strong>TITULAR:</strong> {{ changes.account_holder }}</p>
  <p class="bank-account-info-card__item"><strong>CHAVE PIX:</strong> {{ changes.pix_key }}</p>
</div>
